import React, { useEffect, useState } from 'react'
import ArticlePage from '../../pages/ArticlePage'
import { useLocation } from 'react-router'
import { ArticleGetDetail } from '../../../api/orgService';
import useApi from '../../../api/useApi';
import { toast } from 'react-toastify';

function ArticleAdminRead() {
  const location = useLocation()
  const [publishedData,setPublushedData] = useState({})
  const [editState,setEditState] = useState(false)
  const { request: getAllArticle, data:articleData, error:articleError} = useApi(ArticleGetDetail);

  useEffect(()=>{
    if(location?.state){
      getAllArticle(location?.state?.articleId)
    }else if(location?.state === null){
      // console.log(location?.pathname.split("/"))
      if(location?.pathname?.includes("/staff/article/detail/")){
      getAllArticle(location?.pathname.split("/")[4])
    }
    }
  },[location])

  useEffect(()=>{
    if (articleData?.status===200) {
      setPublushedData(articleData?.data);
    }
  },[articleData])

  useEffect(()=>{
      if(articleError){
          toast.error(`${JSON.stringify(articleError?.response?.data,null,2)}`,{position: "top-center"});
    }
  },[articleError])

  // console.log(publishedData)

  return (
    <div>
        <ArticlePage articleData={publishedData} isArticleAdminRead={true}/>
    </div>
  )
}

export default ArticleAdminRead